import React from "react";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

const accessLabels = {
  cross: "CROSS",
  funcional: "FUNCIONAL",
  maquinas: "MAQUINAS",
};

export default function MembershipDeleteModal({
  open,
  onClose,
  onConfirm,
  plan,
  loading,
}) {
  const title = plan?.name || "Membresía";
  const subtitle =
    plan?.usage_type === "visits"
      ? "Membresía por visitas"
      : "Membresía por tiempo";

  const accesses = Array.isArray(plan?.available_accesses) ? plan.available_accesses : [];

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: "18px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: "#0f172a",
          pb: 1,
        }}
      >
        Eliminar membresía
      </DialogTitle>

      <DialogContent sx={{ pt: "8px !important" }}>
        <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1.4 }}>
          <Avatar
            sx={{
              width: 42,
              height: 42,
              fontSize: 15,
              fontWeight: 700,
              bgcolor: "rgba(59,130,246,0.12)",
              color: "#1d4ed8",
              border: "1px solid rgba(148,163,184,0.18)",
            }}
          >
            {title.charAt(0).toUpperCase()}
          </Avatar>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 700,
                color: "#0f172a",
                lineHeight: 1.3,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: 12.6,
                color: "#64748b",
                lineHeight: 1.35,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {subtitle}
            </Typography>
          </Box>
        </Stack>

        {!!accesses.length && (
          <Box
            sx={{
              border: "1px solid rgba(148,163,184,0.18)",
              borderRadius: "14px",
              p: 1.3,
              bgcolor: "#f8fafc",
              mb: 1.4,
            }}
          >
            <Typography
              sx={{
                fontSize: 12.6,
                fontWeight: 700,
                color: "#475569",
                mb: 0.9,
              }}
            >
              Accesos disponibles
            </Typography>

            <Stack direction="row" spacing={0.8} useFlexGap flexWrap="wrap">
              {accesses.map((access) => (
                <Chip
                  key={access}
                  label={accessLabels[access] || String(access).toUpperCase()}
                  size="small"
                  sx={{
                    height: 28,
                    borderRadius: "8px",
                    fontSize: 11.8,
                    fontWeight: 700,
                    bgcolor: "rgba(59,130,246,0.10)",
                    color: "#1d4ed8",
                    border: "1px solid rgba(59,130,246,0.20)",
                  }}
                />
              ))}
            </Stack>
          </Box>
        )}

        <Typography
          sx={{
            fontSize: 14,
            color: "#475569",
            lineHeight: 1.6,
          }}
        >
          ¿Seguro que deseas eliminar{" "}
          <Box component="span" sx={{ fontWeight: 700, color: "#0f172a" }}>
            {title}
          </Box>
          ?
        </Typography>

        <Typography
          sx={{
            mt: 1.2,
            fontSize: 13,
            color: "#64748b",
            lineHeight: 1.5,
          }}
        >
          Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.2, pt: 1 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loading}
          sx={{
            height: 36,
            px: 1.4,
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12.8,
            color: "#334155",
            bgcolor: "#ffffff",
            borderColor: "rgba(51,65,85,0.18)",
            "&:hover": {
              borderColor: "rgba(51,65,85,0.28)",
              bgcolor: "#f8fafc",
            },
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading || !plan}
          sx={{
            height: 36,
            px: 1.4,
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12.8,
            bgcolor: "#0f172a",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#111827",
              boxShadow: "none",
            },
          }}
        >
          {loading ? "Eliminando..." : "Eliminar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
} 